import template from './index.jst';
import './index.styl';
import { CorePrizes } from "../../../views";

export default class PrizesView extends CorePrizes {
	get className() {
		return "help-page prizes-page";
	}

	get template() {
		return template;
	}
	initialize() {
		this.listenTo(this.model, 'change', this.render);
	}
	templateContext() {
		return {
			winners: this.model.get('winners')
		};
	}
}